module.exports = __webpack_public_path__ + "img/QOOKER_Box05.f6222a3e.jpg";